import { FormattedDate, FormattedMessage, FormattedTime, useIntl } from 'react-intl';

import type { Tour } from '#domain/model/Tour.ts';

const FormattedDateTime = ({ value }: { value: string }) => (
    <>
        <FormattedDate value={value} dateStyle={'short'} />
        <span>{' / '}</span>
        <FormattedTime value={value} />
    </>
);

export const TourStopProgressHeader = ({ tour, title }: { tour: Tour; title?: string }) => {
    const intl = useIntl();

    const headerTitle =
        title ??
        (tour.firstStop && tour.lastStop ? `${tour.firstStop.name} -> ${tour.lastStop.name}` : tour.searchName);
    return (
        <div className='display-flex gap-5'>
            <div className='display-flex flex-column gap-3'>
                <div className='text-medium line-height-125rel padding-right-25'>{headerTitle}</div>
                <div className='display-flex align-items-center gap-5'>
                    {tour.status === 'planned' && (
                        <span className='uikit-icon icon-eye-close text-size-12 text-color-info' />
                    )}
                    {tour.firstStop && tour.lastStop && (
                        <span className='text-size-11 text-medium'>
                            <FormattedDateTime value={tour.firstStop.startTarget} />
                            <span>{' - '}</span>
                            <FormattedDateTime value={tour.lastStop.endTarget} />
                        </span>
                    )}
                    <span className='display-flex align-items-center gap-3'>
                        <span className='text-size-11 text-medium'>|</span>
                        <span className='text-size-11 text-medium'>{tour.progress.finishedStopAmount}</span>{' '}
                        <span className='text-size-11 text-medium'>
                            {intl.formatMessage({
                                id: 'intl-msg:ordercom-cloud-frontend.tours.stop-details.progressHeader.stopsOf',
                            })}
                        </span>{' '}
                        <span className='text-size-11 text-medium'>{tour.progress.totalStopAmount} Stops</span>
                    </span>
                </div>
                {tour.status === 'problem' && (
                    <div className={'display-flex align-items-center flex-shrink-0 gap-3 margin-top-5'}>
                        <div className='label label-danger'>
                            <span className='uikit-icon icon-flash' />
                            <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.tour.problem.label'} />
                            {tour.problem?.type && (
                                <>
                                    <span>: </span>
                                    <FormattedMessage
                                        id={`intl-msg:ordercom-cloud-frontend.tour.problem.${tour.problem.type}`}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
